export const openNewTabSafe = (url: string) => {
  if (!url) return;
  const normalizedUrl =
    url.startsWith("http://") || url.startsWith("https://")
      ? url
      : `https://${url}`;

  window.open(normalizedUrl, "_blank", "noopener");
};

export const normalizeWebsiteURL = (rawUrl: string): string | null => {
  if (!rawUrl) return null;

  const trimmedUrl = rawUrl.trim();
  if (!trimmedUrl) return null;

  const hasProtocol = /^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//.test(trimmedUrl);
  const protocolUrl = hasProtocol ? trimmedUrl : `https://${trimmedUrl}`;

  try {
    const parsedUrl = new URL(protocolUrl);
    const hostnameParts = parsedUrl.hostname.split(".").filter(Boolean);

    if (hostnameParts.length < 2) return null;

    const hasWwwPrefix = parsedUrl.hostname.toLowerCase().startsWith("www.");
    if (!hasWwwPrefix && hostnameParts.length === 2) {
      parsedUrl.hostname = `www.${parsedUrl.hostname}`;
    }

    return parsedUrl.toString();
  } catch {
    return null;
  }
};
